<template>
  <div class="pagews">
    <el-pagination background layout="prev, pager, next" :total="tootle" :page-size="pageSize" :pager-count="5" :current-page="currentPage"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
  export default {
    props: {
      tootle: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 1
      },
      currentPage: {
        type: Number,
        default: 1
      }

    },
    data() {
      return {

      }
    },
    methods: {
      handleCurrentChange(val) {
        this.$emit('counterchange',val)
      }
    }
  }
</script>
<style scoped>
  .pagews {
    width: 1200px;
    margin: 0 auto 20px auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/page.vue